

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage, ref, getDownloadURL,getBytes, uploadString } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  /*apiKey: "AIzaSyANatga4hMyJFIgsSgqNMmbuVF1GM4OlYk",
  authDomain: "decibel-detect.firebaseapp.com",
  projectId: "decibel-detect",
  storageBucket: "decibel-detect.appspot.com",
  messagingSenderId: "678920035796",
  appId: "1:678920035796:web:adf66195555d71478c4a41",
  measurementId: "G-X83R0XGS61"*/

  
  apiKey: "AIzaSyD6gpDKONFEoh4SkH48j8DXfyxQKHOagBw",
  authDomain: "jected-2bfb3.firebaseapp.com",
  databaseURL: "https://jected-2bfb3.firebaseio.com",
  projectId: "jected-2bfb3",
  storageBucket: "jected-2bfb3.appspot.com",
  messagingSenderId: "1032287375176",
  appId: "1:1032287375176:web:34e79d272814e13288ad7d",
  measurementId: "G-4G5STLEKX3"

  /*
  apiKey: "AIzaSyD6gpDKONFEoh4SkH48j8DXfyxQKHOagBw",
  authDomain: "jected-2bfb3.firebaseapp.com",
  projectId: "jected-2bfb3",
  storageBucket: "jected-2bfb3.appspot.com",
  messagingSenderId: "1032287375176",
  appId: "1:1032287375176:web:5fde1113df6d33ec88ad7d",
  measurementId: "G-33DHRXF3R7"*/
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);


export { storage,auth };
export default app;